<div class="list" [loading]="loading">
  <div *ngIf="!loading">

    <div class="mb-10">
      <a (click)="onBack()" class="button"><i class="fa fa-chevron-left mr-5"></i> Zpět</a>
    </div>

    <div>
      <h1>Zařazení dokumentu {{ document.name }}</h1>
    </div>

    <div class="mt-30">
      <div class="column-100">
        <div class="label">Název</div>
        <div class="info">{{ document.name }}</div>
        <div class="label">Číslo jednací dokumentu</div>
        <div class="info">{{ document.referenceNumber }}</div>
        <div class="label">PID</div>
        <div class="info">{{ document.pid }}</div>
        <div class="label">MPV ID</div>
        <div class="info">{{ document.id }}</div>
        <div class="label">Podoba</div>
        <div class="info">{{ document.analog ? 'Analogová' : 'Digitální' }}</div>
        <div class="label">Způsob vytvoření dokumentu</div>
        <div class="info">{{ document.sourceType | documentSourceTypeName }}</div>
        <div class="label">Počet komponent</div>
        <div class="info">{{ document.components.length }}</div>
        <div class="label">Vytvořeno</div>
        <div class="info">{{ document.timestamp | date : 'short' }}</div>
        <div class="label">Poznámka</div>
        <div class="info">{{ document.note }}</div>
      </div>

      <div class="cb"></div>
    </div>



    <div class="mt-10">
      <h2>Komponenty</h2>
      <table class="component-table">
        <tr *ngFor="let component of document.components" class="pb-10">
          <td><span class="label">Název komponenty</span></td>
          <td><a href="{{restBaseUrl}}/documents/{{document.id}}/components/{{component.id}}/content?t={{authToken}}" title="Stáhnout" target="_blank">{{ component.name }}</a></td>
          <td class="text-right">
            <span *ngIf="!component.attachmentType"><i class="fa fa-exclamation-triangle color-red"></i> </span>
            <span class="required">Typ komponenty</span>
          </td>
          <td>
            <gmt-select
              [optionItems]="attachmentTypes"
              [data]="assignedAttachmentTypes"
              [field]="component.id + ''"
              [required]="true"
              [itemPipe]="attachmentTypePipe"
              (changed)="onAssignAttachmentType(component, $event.newValue)"
            ></gmt-select>
          </td>
        </tr>
      </table>
    </div>

    <div class="mt-30">
      <h2>Výběr umístění Dokumentu EPD</h2>
      <div *ngIf="selectedEntity">
        <filter *ngIf="selectedEntity.list.filter.filters.searchText" [list]="selectedEntity.list" (onChanged)="selectedEntity.pageableList.onFilterChanged($event)" filterButtonName="Vyhledat">
          <span style="padding-right: 10px; padding-top: 5px;">Zvolit oblast vyhledání</span>
          <gmt-switch [options]="entityTabs" (select)="onChangeEntity($event.id)" [selected]="selectedEntity"></gmt-switch>
          <a (click)="onItemSelect($event)" class="button">Zařadit do karty akce</a>
          <div class="column-100">
            <input class="fulltext" autocomplete="off" type="text" placeholder="Fultextové hledání..." [(ngModel)]="selectedEntity.list.filter.filters.searchText.values[0].id"/>
          </div>
        </filter>

        <div [loading]="!selectedEntity.list || selectedEntity.list.loading">
          <div *ngIf="selectedEntity.list">
            <table-cases *ngIf="selectedEntity.id === 'cases'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [customColumns]="selectedEntity.columns" [caseStatusType]="'progress'" [clickable]="true" (toggleCheckItem)="onItemSelect($event, 'case')"></table-cases>
            <table-parcels *ngIf="selectedEntity.id === 'parcels'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [geometricPlanModuleEnabled]="false" [opinionModuleEnabled]="false" [clickable]="true" (onclick)="onItemSelect($event, 'parcel')"></table-parcels>
            <table-titles *ngIf="selectedEntity.id === 'titles'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [customColumns]="selectedEntity.columns" [clickable]="true" (toggleCheckItem)="onItemSelect($event, 'title')"></table-titles>
            <table-subjects *ngIf="selectedEntity.id === 'subjects'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [clickable]="true" (onclick)="onItemSelect($event, 'subject')"></table-subjects>
            <table-opinion-request *ngIf="selectedEntity.id === 'opinions'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [clickable]="true" (onclick)="onItemSelect($event, 'opinionRequest')"></table-opinion-request>
            <table-geometric-plan-request *ngIf="selectedEntity.id === 'geometricPlans'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [clickable]="true" (onclick)="onItemSelect($event, 'geometricPlanRequest')"></table-geometric-plan-request>
            <table-construction-object *ngIf="selectedEntity.id === 'constructionObjects'" [list]="selectedEntity.list" (sort)="selectedEntity.pageableList.onSort($event.column, $event.ascOrDesc)" [clickable]="true" (onclick)="onItemSelect($event, 'constructionObject')"></table-construction-object>
          </div>
        </div>

        <div class="flexbox-container">
          <itemscounter *ngIf="selectedEntity.list.itemCount && selectedEntity.list.list !== null" [list]="selectedEntity.list" (callbackRegister)="selectedEntity.pageableList.itemcounterCallbackRegister($event)"></itemscounter>
          <pagescounter *ngIf="selectedEntity.list.itemCount && selectedEntity.list.list !== null" [list]="selectedEntity.list" (callbackRegister)="selectedEntity.pageableList.pagescounterCallbackRegister($event)" class="flex1 mt-5 text-center"></pagescounter>
          <div class="page-count-select mt-5" *ngIf="selectedEntity.list.itemCount && selectedEntity.list.list !== null">
            <span>Záznamů na stránce</span>
            <gmt-select required="true" [data]="selectedEntity.pageableList.dataPaging" field="itemsPerPage" [optionItems]="selectedEntity.pageableList.itemsPerPageItems" (changed)="selectedEntity.pageableList.changePageItems()" class="min-width-unset"></gmt-select>
          </div>
        </div>

        <div>
          <pagination
            *ngIf="selectedEntity.list.itemCount && selectedEntity.list.list !== null"
            [shouldUpdateUrl]="false"
            [list]="selectedEntity.list"
            (pageChanged)="onPageChanged($event)"
            (callbackRegister)="selectedEntity.pageableList.paginationCallbackRegister($event)"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</div>
